<template>
  <div class="lassox-featured-teaser basic">
    <div class="prospecting-teaser" :class="isFrontPage ? 'narrow-teaser' : 'wide-teaser'">
      <img src="@/assets/img/prospecting_lassoDK.png" alt="Prospecting visualisering" class="banner-visual" />
      <h3 v-if="companyName">{{ headerText }} {{ companyName }}</h3>
      <h3 v-else>{{ headerText }}</h3>
      <p>Prøv vores nye prospecting værktøj med en gratis bruger</p>
      <LassoxLink path="prospecting"
        :trackingEventName="`EXP-92 prospecting ${headerText}`"
        :dialogOptions="{
          lassoxIntro: {
            title: headerText,
            text: 'Få adgang til værktøjet prospecting, der leverer leads inden for din målgruppe hver uge – alt sammen helt gratis.',
            image: require('@/assets/img/prospecting_lassoDK.png'),
            color: 'pink'
          }
        }">
        <Button theme="red" label="Opret gratis bruger" class="signup-button"></Button>
      </LassoxLink>
    </div>
  </div>
</template>

<script>
import userStore from '@/modules/users/store'
import LassoxLink from './LassoxLink.vue'
import Button from '@/components/Button.vue'
import { getCurrentLassoId } from '@/router/router'
import { isTestGroupA } from '@/utils/abTest'

export default {
  name: 'lassoxFeaturedAd',

  components: {
    LassoxLink,
    Button
  },

  data() {
    return {
      backgroundImage: '',
    }
  },

  computed: {
    previewContent: function () {
      return this.newsItem.content.replace(new RegExp('/li>', 'g'), '/li>, ').replace(/<[^>]*>/g, '')
    },

    headerText () {
      return this.companyName ? 'Find firmaer der ligner' :
        isTestGroupA() ? 'Spar tid på din leadgenerering' : 'Vil du have kvalitetsleads automatisk?'
    },

    isLoggedIn() {
      return !!userStore.user
    },

    isChromium() {
      return window.chrome
    },

    isMobile() {
      return navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    },

    companyName() {
      return this.$store.state.entities[getCurrentLassoId()]?.company?.name
    },

    isFrontPage() {
      return this.$route.matched.some(({ name }) => name === 'home')
    },

    isPersonPage() {
      return this.$route.matched.some(({ name }) => name === 'person')
    }
  },

  methods: {
    seeSolutions() {
      this.$root.trackEvent({ eventCategory: 'Click', eventAction: 'Se Lasso løsninger', eventLabel: this.$route.fullPath })
      this.$nextTick(() => window.location.href = "https://lassox.com")
    },
    openChromeExtensionPage() {
      window.open('https://chrome.google.com/webstore/detail/lasso/jfckcnmdnodpdnikacobpdnnmipaogcm', '_blank')
    },
  }
}
</script>

<style lang="less" scoped>
@import (reference) "~@oldShared/lasso/style/constants/colors";
// rules to keep in mind
// narrow (1/4 wide or less) can be visible from sm and up

.content-box {
  padding: 0;

}

.signup-button {
  background-color: #FF7B7E;
}

.lassox-featured-teaser {
  position: relative;
  text-align: center;
  height: 100%;

  .btn-primary {
    width: 50%;
    display: inline-block;
  }

  button.btn {
    padding: 4px 19px;
    border-color: #fe8191 !important;
    color: #fff !important;
    height: 34px !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
      box-shadow: 0 1px 10px -5px rgb(0, 0, 0, 0.5) !important;
    }
  }

  .prospecting-teaser {
    border-radius: 32px;
    padding: 44px 28px;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    text-align: left;

    &.narrow-teaser{

      background: linear-gradient(163deg, rgba(255, 129, 145, 0.00) 1.95%, rgba(255, 129, 145, 0.30) 98.95%), #FFF;
      @media (min-width: 350px) and (max-width: 768px) {
        align-items: center;
        text-align: center;
      }
    }
    .banner-visual {
      width: 160%;
      max-width: 370px;
      user-select: none;
      -webkit-user-drag: none;
      margin-bottom: auto;
    }

    h3 {
      font-size: 25px;
      font-weight: 700;
      line-height: 30px;
      color: #262626;
      margin-bottom: 12px;
      max-width: 290px;
    }

    p {
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      color: #616161;
      margin-bottom: 25px;
      max-width: 280px;
    }

    &.wide-teaser {
      background: #FEFAFA;
      background: linear-gradient(245deg, rgba(255, 129, 145, 0.24) 0%, rgba(255, 129, 145, 0.00) 117.71%), #FFF;
      align-items: left;
      text-align: left;
      padding: 40px;
      padding-bottom: 0;

      h3 {
        font-size: 22px;
        margin-bottom: 16px;
        max-width: 100%;
      }

      p {
        margin-bottom: 16px;
        font-weight: 400;
        max-width: 100%;
      }

      .banner-visual {
        order: 3;
        max-width: 420px;
        margin-left: 10%;
        @media (min-width: 400px){
          margin-left: 23%;
        }
        margin-top: -20px;
        // Compensating for the image's shadows making it taller than it looks
        margin-bottom: -10px;
      }
    }
  }

  .logo {
    img {
      margin: 0 auto;
      width: 240px;
    }
  }

  .content {
    padding: 15px;
    color: #3D464A;

    h3 {
      font-size: 27px;
      line-height: 29px;
      margin: 0 0 15px 0;
      font-weight: 700;
      word-break: break-word;

      a {
        color: inherit;

        &:hover {
          color: #FF8E61;
          text-decoration: none;
        }
      }
    }

    p {
      margin: 0;
      font-size: 13px;
      line-height: 21px;
    }

    .btn-lassox-link {}
  }
}



#app.min-sm {
  .lassox-featured-teaser {
    &.highlight {
      .image {
        min-height: 275px;
      }

      .content {
        h3 {
          margin-bottom: 0;
        }
      }
    }

    &.basic {
      text-align: center;

      &.narrow-teaser {
        .image {
          min-height: 150px;
        }

        h3 {
          font-size: 20px;
        }
      }

      &.tall {
        .image {
          min-height: 250px;
        }
      }
    }
  }

  #home {
    .lassox-featured-teaser {
      &.basic {
        text-align: left;
      }
    }
  }
}

#app.min-md .lassox-featured-teaser {
  &.highlight {
    display: flex;
    align-items: stretch;

    .image {
      width: 50%;
      min-height: 200px;
      border-radius: 3px 0 0 3px;
    }

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;

      h3 {
        margin-bottom: inherit
      }
    }
  }

  &.basic {
    &.narrow-teaser {
      .image {
        min-height: 150px;
      }

      h3 {
        font-size: 20px;
      }
    }

    &.tall {
      .image {
        min-height: 300px;
      }
    }
  }
}

#app.lg .lassox-featured-teaser {
  &.highlight {
    .image {
      width: 58.333%;
    }
  }
}</style>